import React, { useEffect, useState, useCallback } from "react";
import { Loader2, History as HistoryIcon, Search } from "lucide-react";
import DashboardShell from "@/shared/ui/DashboardShell";
import { historyService } from "@/shared/api/historyService";
import { HistoryGetDTO } from "@/shared/types/admin";
import { DEFAULT_PAGE_SIZE } from "@/shared/config/pagination";
import { formatDateTime, formatDate } from "@/shared/lib/formatters";

export default function HistoryPage() {
    const [history, setHistory] = useState<HistoryGetDTO[]>([]);
    const [loading, setLoading] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = DEFAULT_PAGE_SIZE;

    const [filterUsername, setFilterUsername] = useState("");
    const [filterDate, setFilterDate] = useState("");

    const fetchHistory = useCallback(async () => {
        try {
            setLoading(true);
            const data = await historyService.getAll({
                page: currentPage,
                size: itemsPerPage,
                filter: {
                    username: filterUsername || undefined,
                    date: filterDate || undefined
                },
            });

            setHistory(data.content || []);
            setTotalItems(data.totalElements);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        } finally {
            setLoading(false);
        }
    }, [currentPage, filterUsername, filterDate]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    const HistoryFilter = (
        <div className="bg-white dark:bg-night_surface p-4 rounded-lg border border-light_gray dark:border-zinc-700 shadow-sm mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                <div>
                    <label className="block text-sm font-bold text-dark_gray dark:text-zinc-300 mb-1">
                        Usuário
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            value={filterUsername}
                            onChange={(e) => setFilterUsername(e.target.value)}
                            placeholder="Buscar por usuário..."
                            className="w-full rounded-lg border border-light_gray dark:border-zinc-700 p-2 pl-9 text-sm outline-none focus:border-dark_green transition-colors"
                        />
                        <Search size={16} className="absolute left-3 top-2.5 text-slate-600 dark:text-zinc-400" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-bold text-dark_gray dark:text-zinc-300 mb-1">
                        Data
                    </label>
                    <input
                        type="date"
                        value={filterDate ? filterDate.split('T')[0] : ''}
                        onChange={(e) => setFilterDate(e.target.value ? new Date(e.target.value).toISOString() : "")}
                        className="w-full rounded-lg border border-light_gray dark:border-zinc-700 p-2 text-sm outline-none focus:border-dark_green transition-colors"
                    />
                </div>
                <div>
                </div>
            </div>
        </div>
    );

    return null; // Page disabled by backend request
    /*
    return (
        <DashboardShell>
            <div className="w-full relative">
                <Table
                title="Histórico de Ações"
                columns={["Data Criação", "Criado Por", "Data Atualização", "Atualizado Por"]}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                filterContent={
                    <div className="bg-white dark:bg-night_surface p-4 rounded-lg border border-light_gray dark:border-zinc-700 shadow-sm mb-6">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                            <div>
                                <label className="block text-sm font-bold text-dark_gray dark:text-zinc-300 mb-1">
                                    Usuário
                                </label>
                                <input
                                    type="text"
                                    value={filterUsername}
                                    onChange={(e) => setFilterUsername(e.target.value)}
                                    placeholder="Buscar por usuário..."
                                    className="w-full rounded-lg border border-light_gray dark:border-zinc-700 p-2 text-sm outline-none focus:border-dark_green transition-colors"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-dark_gray dark:text-zinc-300 mb-1">
                                    Data
                                </label>
                                <input
                                    type="date"
                                    // Handle date string format
                                    onChange={(e) => setFilterDate(e.target.value ? new Date(e.target.value).toISOString() : "")}
                                    className="w-full rounded-lg border border-light_gray dark:border-zinc-700 p-2 text-sm outline-none focus:border-dark_green transition-colors"
                                />
                            </div>
                            <button
                                onClick={fetchHistory}
                                className="bg-dark_green text-white py-2 px-4 rounded-lg hover:opacity-90 transition-opacity font-bold shadow-sm text-sm h-[38px] flex items-center justify-center gap-2"
                            >
                                <Search size={16} /> Pesquisar
                            </button>
                        </div>
                    </div>
                }
            >
                {loading ? (
                    <tr>
                        <td colSpan={4} className="text-center p-10 text-dark_gray dark:text-zinc-300">
                            <div className="flex justify-center items-center gap-2">
                                <Loader2 className="animate-spin" /> Carregando histórico...
                            </div>
                        </td>
                    </tr>
                ) : history.length === 0 ? (
                    <DataTableEmpty colSpan={4} icon={<HistoryIcon size={40} />} message="Nenhum registro encontrado." />
                ) : (
                    history.map((item, index) => (
                        <DataTableRow key={index} index={index}>
                            <DataTableCell className="font-medium">{formatDate(item.createdAt)}</DataTableCell>
                            <DataTableCell>{item.createdBy || "-"}</DataTableCell>
                            <DataTableCell>{formatDate(item.updateAt)}</DataTableCell>
                            <DataTableCell>{item.updateBy || "-"}</DataTableCell>
                        </DataTableRow>
                    ))
                )}
            </Table>
            </div>
        </DashboardShell>
    );
    */
}

